import { render } from "./LatencyBarIcons.vue?vue&type=template&id=87b70262"
import script from "./LatencyBarIcons.vue?vue&type=script&lang=js"
export * from "./LatencyBarIcons.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__